import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconVoxelsize = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 5.292 5.292",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fillRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.5,
		strokeWidth: .832,
		clipRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				d: "m1337.8 281.771 5.75 2.282-5.75 2.281-5.75-2.281z",
				transform: "matrix(.21006 0 0 .23582 -278.372 -66.008)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				d: "m1337.8 281.771 5.75 2.282-5.75 2.281-5.75-2.281z",
				transform: "matrix(.21006 0 0 .23582 -279.58 -64.071)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				d: "m1337.8 281.771 5.75 2.282-5.75 2.281-5.75-2.281z",
				transform: "matrix(.21006 0 0 .23582 -277.16 -64.071)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				d: "m1332.05 290.005 5.75 2.281v-5.952l-5.75-2.281z",
				transform: "matrix(.21006 0 0 .23582 -278.372 -66.008)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				d: "m1332.05 290.005 5.75 2.281v-5.952l-5.75-2.281z",
				transform: "matrix(.21006 0 0 .23582 -279.58 -64.071)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				d: "m1332.05 290.005 5.75 2.281v-5.952l-5.75-2.281z",
				transform: "matrix(.21006 0 0 .23582 -277.16 -64.071)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				d: "m1332.05 290.005 5.75 2.281v-5.952l-5.75-2.281z",
				transform: "matrix(.21006 0 0 .23582 -278.372 -66.008)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				d: "m1332.05 290.005 5.75 2.281v-5.952l-5.75-2.281z",
				transform: "matrix(.21006 0 0 .23582 -279.58 -64.071)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				d: "m1332.05 290.005 5.75 2.281v-5.952l-5.75-2.281z",
				transform: "matrix(.21006 0 0 .23582 -277.16 -64.071)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				d: "m1332.05 290.005 5.75 2.281v-5.952l-5.75-2.281z",
				transform: "matrix(-.21006 0 0 .23582 283.659 -66.008)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				d: "m1332.05 290.005 5.75 2.281v-5.952l-5.75-2.281z",
				transform: "matrix(-.21006 0 0 .23582 282.451 -64.071)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				d: "m1332.05 290.005 5.75 2.281v-5.952l-5.75-2.281z",
				transform: "matrix(-.21006 0 0 .23582 284.871 -64.071)"
			})
		]
	})
});
export default SvgIconVoxelsize;
